import {
  roundToCents,
  formatPrice,
} from "../components/WebSiteApp/Utilitaires";
export function computeProductPrice({
  product,
  quelCodeActif,
  isPromotional,
  initialMonthlyPrice, // référence tarifaire
}) {
  const info = product.formData || product.options || {};
  const paymentMethod = info.paymentMethod || "once";
  const optionLv3 = info.lv3;
  const optionPrice =
    optionLv3 === "arabe" ? 351 : optionLv3 === "espagnol" ? 300 : 0;
  const productPrice = parseFloat(product.price) || 0;

  let multiplier = 1;
  let label = "";

  switch (paymentMethod) {
    case "month":
      multiplier = 10;
      label = "Mensuel";
      break;
    case "trimester":
      multiplier = 3;
      label = "Trimestriel";
      break;
    case "year":
      label = "Annuel";
      break;
    case "once":
      label = "En 1x";
      break;
    case "twice":
      multiplier = 2;
      label = "En 2x";
      break;
    case "hour":
      const nbHours = parseInt(info?.nbHours || 1);
      multiplier = 4 * nbHours;
      label = "Tarif horaire";
      break;
  }

  const baseTotal = roundToCents(productPrice * multiplier + optionPrice);
  const details =
    multiplier !== 1
      ? `${multiplier} x ${formatPrice(roundToCents(baseTotal / multiplier))} €`
      : "";

  let promoDiscount = 0; //promoDiscount est la différence entre le tarif affiché et le tarif initial réduit

  const initialPrice = roundToCents(initialMonthlyPrice * 10); //initialMonthlyPrice est à 0 s'il n'y a pas de prix mensuel (month)

  if (quelCodeActif && isPromotional) {
    if (quelCodeActif === "FIDELITE26" || quelCodeActif === "CURSUSEVE26") {
      const isAnnual = paymentMethod === "year";
      const coeffRed = isAnnual ? 0.8 : 0.9;
      const reducedInitialPrice = roundToCents(
        initialMonthlyPrice * 10 * coeffRed + optionPrice,
      );

      promoDiscount = roundToCents(baseTotal - reducedInitialPrice);
    }

    if (quelCodeActif === "STAGE26") {
      promoDiscount = 50;
    }

    if (quelCodeActif === "JUILLET20") {
      const reducedInitialPrice = roundToCents(
        initialMonthlyPrice * 10 * 0.8 + optionPrice,
      );
      promoDiscount = roundToCents(baseTotal - reducedInitialPrice);
    }
  }

  return {
    //apparaissent dans le panier à gauche
    label,
    reference: initialPrice,
    //apparaissent dans le panier à droite
    baseTotal,
    details,
    promoDiscount,
    //n'apparaissent pas dans le panier
    finalTotal: roundToCents(baseTotal - promoDiscount),
    isInstallmentPayment: [2, 3, 10].includes(multiplier),
    installment: productPrice,
  };
}
